import api from '@/configurations/service';
import * as types from './mutation-types';

export const resetOsSituationsState = async (context) => {
  context.commit(types.RESET_OS_SITUATION);
};

export const setSummaryOsSituations = async (context, { search, pagination }) => {
  const body = { search, pagination };
  const { data } = await api().post('consumers.find-summary-service-order-situations', body);

  context.commit(types.SET_SUMMARY_OS_SITUATIONS, data.data);
  context.commit(types.SET_PAGINATION_OS_SITUATIONS, data.pagination);
};

export const saveOsSituation = async (_, payload) => {
  const { id } = payload;

  if (!id) {
    await api().post('consumers.register-service-order-situation', payload);
    return;
  }

  await api().post('consumers.update-service-order-situation', payload);
};

export const deleteOsSituations = async (_, ids) => {
  const { data } = await api().post('consumers.delete-service-order-situations', { ids });

  return data;
};

export const setDetailedOsSituation = async (context, id) => {
  const { data } = await api().post('consumers.find-service-order-situation', { id });

  context.commit(types.SET_DETAILED_OS_SITUATION, data);
};
